import { gql } from '@apollo/client';

export const GET_PACKAGES_LIST = gql`
  query GetPackagesList {
    packagesList {
      segment
      packages {
        name
        price
        discount
        paidAdsCount
        walletAmount
        promotions
        periods {
          value
          price
        }
      }
    }
  }
`;
